import { netsparkAxios } from 'core/services/HTTPService';
import { getBookingCSDataUrl } from 'pages/Dashboard/api/apiUrls';
import { IRequestPaging } from 'core/services/HTTPService.models';
import { IBookingDataItem } from '@dashboardWireline/WirelineDepartments/WIrelineDepartament.models';

const getBookingCSData = (signal: AbortSignal, params: object) => netsparkAxios
  .get<IRequestPaging<IBookingDataItem[]>>(getBookingCSDataUrl, { signal, params });

export default getBookingCSData;
